import { Outlet } from 'react-router-dom';
import { MessageCircle, Phone } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import TextNowLink from './TextNowLink';
import { CONTACT } from '../data/siteData';

export default function Layout() {
  return (
    <div className="site-shell">
      <Header />
      <main><Outlet /></main>
      <Footer />
      <div className="floating-help" aria-label="Quick contact actions">
        <TextNowLink className="floating-help__text" title="Text dispatch and optionally share your GPS location"><MessageCircle size={20} /><span>Text dispatch</span></TextNowLink>
        <a href={CONTACT.phoneHref} data-roka-cta="call_dispatch" data-roka-label="Call dispatch" aria-label="Call Jonny's Towing dispatch"><Phone size={20} /><span>Call dispatch</span></a>
      </div>
    </div>
  );
}
